import React, { Component } from 'react';

class PowerUserHome extends Component {
  state = {  } 
  render() { 
    return (<h1>Home</h1>);
  }
}
 
export default PowerUserHome;